<template>

  <!-- Save Popup -->
  <van-popup
      class="single-edit-popup main-color"
      :value="value"
      @input="onShowChange"
      round
      :style="{ width: '64%' }"
      :close-on-click-overlay="false"
  >
    <div class="single-edit-title">{{ title }}</div>

    <div class="single-edit-msg" v-if="message">
      {{ message }}
    </div>
    <input
        class="input"
        type="text"
        v-model="content"
        :placeholder="placeholder"
    />


    <div class="footer">
      <button
          class="footer-cancel radius-border"
          @click="onCancelClick"
      >
        Cancel
      </button>
      <button class="footer-confirm" @click="onConfirmClick">
        Apply
      </button>
    </div>
  </van-popup>
</template>

<script>
import log from "@/util/log";

export default {
  name: "PopupSingleEdit",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    },
    initContent: {
      type: String,
      default: ""
    },
    message: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    maxLength: {
      type: Number,
      default: 10
    },
  },
  data() {
    return {
      showPopup: false,
      content: ""
    };
  },
  watch: {
    value(newVal) {
      if (newVal) {
        this.content = this.initContent
      }
    }
  },
  methods: {
    onDeviceNameChange() {
      const value = this.content;
      if (value.length >= this.maxLength) this.content = value.slice(0, this.maxLength);
      this.$emit("onDeviceNameChange", this.content);
    },
    onShowChange(e) {
      log(`单行编辑框弹框 ${e}`);
      this.$emit("input", e);
    },
    onCancelClick() {
      log(`单行编辑框弹框 取消 `);
      this.$emit("input", false);
      this.$emit("onCancel");
    },
    onConfirmClick() {
      log(`单行编辑框弹框 确认 ${this.content}`);
      this.$emit("onConfirm", this.content);
    }
  },
  mounted() {
    this.showPopup = this.show;
    this.content = this.initContent
  }
};
</script>


<style scoped lang="less">

.single-edit-popup {
  font-size:16px;
  padding: 16px;
  text-align: center;

  & > * + * {
    margin-top: 16px;
  }

  .single-edit-title {
    font-size: 20px;
    text-align: center;
    width: 100%;
  }

  .single-edit-content {
    padding: 15px 23px 20px 23px;
    font-size: 18px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }


  .single-edit-msg {

  }

  .input {
    width: 100%;
    padding: 0 16px;
  }

  .footer {
    display: flex;
    align-items: center;

    .footer-cancel {
      margin-top: 16px;
      margin-right: 5px;
      width: 100%;
      height: 40px;
      font-weight: normal;
      color: #333333;
    }

    .footer-confirm {
      margin-top: 16px;
      margin-left: 5px;
      height: 40px;
      color: #ffffff;
      background: var(--themeMainColor);
      width: 100%;
      font-weight: normal;
    }
  }
}
</style>